export const useNativeWebComponentEvents = (element: HTMLElement | undefined) => {
  const emitCustomEvent = (eventType: string, eventPayload: object) => {
    const event = new CustomEvent(eventType, {
      detail: eventPayload,
      bubbles: true,
      composed: true,
    })

    // Since <script setup> doesn't expose `this`, we can use the component's `root` element.
    element?.dispatchEvent(event)
  }

  return {
    emitCustomEvent,
  }
}
